import { z } from 'zod';
import { ContributionInformationAggregationResultSchema, ESAggregationResultSchema } from './commons';
import { DemandeFinancementSchema, FormattedDemandeFinancementSchema, } from './demandes-financement';
//====================================================
// Demande actions enum
//====================================================
export const DemandesApprenantsActions = {
    ACCESS: 'access',
    CONTRIBUTION_INFORMATION: 'contribution-information',
};
//====================================================
// Api returned demande
//====================================================
export const DemandeApprenantSchema = DemandeFinancementSchema.pick({
    id: true,
    reference: true,
    referenceAdministrative: true,
    title: true,
    history: true,
    primaryActions: true,
    secondaryActions: true,
    cloture: true,
    teleservice: true,
    virtualHistory: true,
    bourse: true,
    contributionVef: true,
});
//====================================================
// Aggregations Apprenants
//====================================================
export const AggregationsApprenantsSchema = z.object({
    libelleTeleservice: ESAggregationResultSchema.optional(),
    bourseFormationTitle: ESAggregationResultSchema.optional(),
    bourseFormationAnnee: ESAggregationResultSchema.optional(),
    bourseVirtualStatus: ESAggregationResultSchema.optional(),
    contributionsInformation: ContributionInformationAggregationResultSchema.optional(),
});
//====================================================
// Api returned payload
//====================================================
export const DemandesApprenantsResponseSchema = z.object({
    meta: z.object({ total: z.number(), limit: z.number(), offset: z.number() }),
    data: z.array(DemandeApprenantSchema),
    aggregations: AggregationsApprenantsSchema,
});
// Formatted demande apprenant
//====================================================
export const FormattedDemandeApprenantSchema = DemandeApprenantSchema.omit({
    primaryActions: true,
    secondaryActions: true,
    history: true,
}).merge(FormattedDemandeFinancementSchema.pick({
    actions: true,
    subactions: true,
    subActionsBtnLabel: true,
    virtualHistoryDetails: true,
    status: true,
    teleservice: true,
}));
//# sourceMappingURL=demandes-apprenants.js.map